import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../../utils/consts/routes";
import { SectionHeading } from "../../../../atom/SectionHeading";
import { ProfessionalTraining } from "../../../../../types/components";
import { ProfessionalTrainingOverview } from "../../../../atom/ProfessionalTrainingOverview";

interface ProfessionalTrainingSectionProps {
  data?: ProfessionalTraining;
}

export const ProfessionalTrainingSection: React.FC<ProfessionalTrainingSectionProps> = ({
  data,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!data) {
    return;
  }

  const { hours_accepted, year, status } = data;

  return (
    <div className="flex flex-col gap-[24px]">
      <SectionHeading
        title={t("Professional Training")}
        subtitle={t("Check your training status and collected hours.")}
        buttonText={t("View Professional Training")}
        onClick={() => navigate(ROUTES.professionalTraining)}
      />
      <ProfessionalTrainingOverview
        year={year}
        hoursAccepted={hours_accepted}
        statusName={status?.name}
      />
    </div>
  );
};
